import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from './analytics';

export const bootstrap = new BootstrapBrowserBuilder('rental-growth-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({ logPath: `/rental-manager/growth/log` })
  .withOnRegister(analytics.initialize)
  .build();
